/* 1221 · V1.32 (CTRL+G, 4 novembre 2026) · scheda prodotto: taglia non scelta più evidente.
   Lavora sopra il blocco QA-087 di 1221-v131.js (già nel pacchetto 1221-tutto-pdp.js), senza cambiarlo:
   - l'avviso «Scegli la taglia.» passa sopra le caselle, subito sotto «Taglia:»;
   - al clic su «Aggiungi al carrello» (anche dalla barra fissa in basso) senza taglia, le caselle prendono il bordo nero
     e vibrano appena (niente vibrazione con «riduci movimento»). Scelta la taglia, tutto torna normale.
   Si carica solo nelle schede prodotto, dopo il pacchetto (snippets/1221-head). */
(() => {
  const calma = matchMedia('(prefers-reduced-motion: reduce)');

  const sistema = () => {
    document.querySelectorAll('fieldset[data-x131-taglia]:not([data-x132])').forEach((fs) => {
      const avviso = fs.querySelector('.x131-taglia__avviso');
      const info = fs.querySelector('.variant-picker__option-info');
      if (!avviso || !info) return;
      fs.setAttribute('data-x132', '');
      info.after(avviso);
      fs.addEventListener('change', () => fs.classList.remove('x132-errore'));
    });
  };

  const vibra = (fs) => {
    fs.classList.add('x132-errore');
    /* dal secondo clic l'avviso è già visibile: si riscrive perché il lettore di schermo lo ripeta */
    const avviso = fs.querySelector('.x131-taglia__avviso');
    if (avviso && !avviso.hidden) {
      const testo = avviso.textContent;
      avviso.textContent = '';
      requestAnimationFrame(() => { avviso.textContent = testo; });
    }
    const caselle = fs.querySelector('.variant-picker__option-values');
    if (!caselle || calma.matches) return;
    const via = () => {
      caselle.classList.remove('x132-vibra');
      void caselle.offsetWidth;
      caselle.classList.add('x132-vibra');
    };
    /* dalla barra fissa la pagina prima scorre fino alle taglie: la vibrazione parte quando ci si arriva */
    const r = caselle.getBoundingClientRect();
    if (r.top >= 0 && r.bottom <= innerHeight) via(); else setTimeout(via, 600);
  };

  /* window in cattura: arriva prima del blocco QA-087, che poi ferma l'aggiunta al carrello e mostra l'avviso */
  window.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('button[type="submit"], button:not([type]), [name="add"]');
    if (!b) return;
    document.querySelectorAll('fieldset.x131-taglia--vuota[data-x131-taglia]').forEach((fs) => {
      const r = fs.querySelector('input[type="radio"]');
      const id = r && r.getAttribute('form');
      const form = id ? document.getElementById(id) : fs.closest('form');
      if (form && (b.form === form || form.contains(b))) vibra(fs);
    });
  }, true);

  document.addEventListener('animationend', (e) => {
    if (e.animationName === 'x132-vibra') e.target.classList.remove('x132-vibra');
  });

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', sistema, { once: true }) : sistema();
  if (window.x1221Osserva) window.x1221Osserva(() => sistema());
  document.addEventListener('shopify:section:load', sistema);
})();
